"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Typography = require("../../components/Typography");
var _breakpoints = _interopRequireDefault(require("../../components/breakpoints"));
var _IconLibrary = require("../../packages/IconLibrary");
var _default = exports.default = {
  DrawerAccordion: _styledComponents.default.div`
  position: relative;
  padding-left: 10px;
  ${function (_ref) {
    let {
      $showDecorator
    } = _ref;
    return $showDecorator ? `
          &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            width: 2px;
            height: 100%;
            background-color: var(--app-primary-text-color, #000);
          }
        ` : "";
  }}
  `,
  DrawerHeading: (0, _Typography.StyledType)("div", {
    family: "nobel-bold",
    size: "linkCopy2"
  })`
    color: ${function (_ref2) {
    let {
      $color
    } = _ref2;
    return $color || "var(--app-primary-text-color, #000)";
  }};
    margin-bottom: 15px;
  `,
  AccordionButton: _styledComponents.default.button`
    background: none;
    border: none;
    margin: 0 auto;
    ${function (_ref3) {
    let {
      $showDropdown
    } = _ref3;
    return $showDropdown && "padding-bottom: 25px";
  }};
    display: block;
    text-align: center;
    cursor: pointer;
    transform: scale3d(1, 1, 1);
  `,
  Arrow: (0, _styledComponents.default)(_IconLibrary.Arrow)`
    width: 15px;
    margin: 0 auto;
    display: block;
    fill: ${function (_ref4) {
    let {
      $color
    } = _ref4;
    return $color || "var(--app-primary-text-color, #000)";
  }};
    transform: rotateX(${function (_ref5) {
    let {
      $showDropdown
    } = _ref5;
    return $showDropdown ? "0.5turn" : "0turn";
  }});
    transition: 500ms ease all;
  `,
  AccordionTitle: _styledComponents.default.button`
    display: flex;
    padding: 20px 20px;
    background: none;
    border: none;
    width: 100%;
    text-align: left;
    border-bottom: ${function (_ref6) {
    let {
      $active
    } = _ref6;
    return $active ? "0" : "1px solid #d3d3d3";
  }};
    cursor: pointer;
    ${(0, _breakpoints.default)("tablet", "up")} {
      padding: 20px 0;
    }

  `,
  AccordionTitleText: (0, _Typography.StyledType)("div", {
    family: "nobel-regular",
    letterSpacing: "wide"
  })`
    flex: 1;
  `,
  AccordionIcon: _styledComponents.default.div`
    justify-content: flex-end;
    width: 21px;
    height: 1px;
    background: var(--app-primary-text-color, #000);
    align-self: center;
    transform: rotate(179.9deg);
    &:before {
      content: "";
      display: block;
      width: 21px;
      height: 1px;
      background: var(--app-primary-text-color, #000);
      transform: rotate(90deg);
      transition: transform 0.3s;
      ${function (_ref7) {
    let {
      $active
    } = _ref7;
    return $active && "transform: rotate(180deg);";
  }}
    }
  `,
  AccordionContent: _styledComponents.default.div`
  ${function (_ref8) {
    let {
      $show
    } = _ref8;
    return $show ? `
      max-height: unset;
      opacity: 1;
      overflow: visible;
      pointer-events: auto;
      visibility: visible;
      transform: translate3d(0, 0, 0);
    ` : `
      max-height: 0vh;
      opacity: 0;
      overflow: hidden;
      pointer-events: none;
      visibility: hidden;
      transform: translate3d(0, -10px, 0);
    `;
  }}
    perspective: 9999px;
    transform-style: preserve-3d;
    transition: all .6s ease;
    position: relative;
    z-index: 1;
  `
};